import {createCargoCorpRepository} from '@yandex-delivery/api/repo/cargo-corp/external'
import {createCargoCrmRepository} from '@yandex-delivery/api/repo/cargo-crm'
import {createDcaaRepository} from '@yandex-delivery/api/repo/dcaa/external'
import {createDraftRepository} from '@yandex-delivery/api/repo/draft'
import {createPassportRepository} from '@yandex-delivery/api/repo/passport'
import {createGeoService} from '@yandex-delivery/api/service/geo'
import {createOfferService} from '@yandex-delivery/api/service/offer'
import {createOrderService} from '@yandex-delivery/api/service/order'
import {createPaymentCardService} from '@yandex-delivery/api/service/payment'
import {createRegistrationService} from '@yandex-delivery/api/service/registration'

import {appConfig} from '../config'
import {formatOfferInterval} from '../utils'
import {cargoCorpFetch, fetch, passportFetch} from './fetch'
import {suggestService} from './services/fetch-address-suggest'
import {createPickupRouteService} from './services/pickup-route'
import {createPreOrderFormService} from './services/pre-order-form'

export {fetchClosestOfferDeprecated} from './deprecated/fetch-closest-offer'
export {fetchConfirmOfferDeprecated} from './deprecated/fetch-confirm-offer'
export {fetchCreateAccepted} from './deprecated/fetch-create-accepted'
export {fetchDetectLocationDeprecated} from './deprecated/fetch-detect-location'
export {
  type LocationRequest,
  type LocationResponse,
  fetchDetectLocationByCity,
} from './deprecated/fetch-detect-location-by-city'
export {fetchLastOrderId} from './deprecated/fetch-last-order-id'
export {fetchNddDeliveryIntervalsDeprecated} from './deprecated/fetch-ndd-delivery-intervals'
export {fetchOffersInfoDeprecated} from './deprecated/fetch-offers-info'
export {fetchPickUpDropOffPoints} from './deprecated/fetch-pick-up-drop-off-points'
export {fetchRemoveLastOrderId} from './deprecated/fetch-remove-last-order-id'
export {
  fetchMemoizedPollSharing,
  fetchPollSharing,
} from './deprecated/fetch-sharing'
export {fetchStoreLastOrderId} from './deprecated/fetch-store-last-order-id'
export {fetchVerticals as fetchVerticalsDeprecated} from './deprecated/fetch-verticals'
export {fetch}

export {
  type AddressPin,
  type PickupPoint,
  type PickupPointFeature,
  type PickupPointType,
  type PickupPoints,
  type UserAddressPin,
  isPickupPointsWithBounds,
  isPickupPointsWithNearest,
  isUserAddressPin,
  isYandexMarketPickupPoint,
} from './models/pickup-route'
export {fetchAddressFromInitialProps} from './services/fetch-address-from-initial-props'
export {fetchInitialLocation} from './services/fetch-initial-location'
export {fetchOrderAvailability} from './services/fetch-order-availability'
export {fetchRouteFromQuery} from './services/fetch-route-from-query'
export {
  getDestinationCity,
  getSourceCity,
  withEmptyDestinationPoint,
} from './services/utils/with-empty-destination-point'

// ------ REPOSITORY  ------
const passportRepository = createPassportRepository({
  fetch: passportFetch,
})
const cargoCorpRepository = createCargoCorpRepository({
  fetch,
})
const cargoCrmRepository = createCargoCrmRepository({
  fetch: cargoCorpFetch,
})
const dcaaRepository = createDcaaRepository({
  fetch,
})
const draftRepository = createDraftRepository({
  key: `__ya_delivery_order_form_state_v2_${appConfig.device}__`,
})
export const {fetchPreOrderForm} = createPreOrderFormService({
  dcaaRepository,
  suggestService,
  config: {
    country: appConfig.countryCode,
  },
})
export const {
  fetchCards,
  fetchCardBoundContext,
  fetchBoundedCard,
  fetchNotificationsAgreements,
} = createPaymentCardService({
  cargoCorpRepository,
  dcaaRepository,
  config: {
    country: appConfig.countryCode,
    trustDomain: appConfig.trustHost,
  },
})

export const {fetchRegistration, fetchCardBound} = createRegistrationService({
  corpRepository: cargoCorpRepository,
  crmRepository: cargoCrmRepository,
  passportRepository,
})
export const {fetchGpsZone} = createGeoService()
export const {
  fetchPaymentInfo,
  fetchVerticals,
  fetchPersistDraftSync,
  fetchRestoreDraftSync,
  fetchClearDraftSync,
} = createOrderService({
  dcaaRepository,
  draftRepository,
})
export const fetchAllAccountsDeprecated = passportRepository.fetchAllAccounts
const {fetchOffers: fetchOffersService} = createOfferService(dcaaRepository)

// Необходимо форматировать intervalCaption для отображения в интерфейсе именно здесь, так как i18n не доступен в сервисе.
// Прокидывать как еще один параметр в сервис нецелесообразно, так может дойти до использования миллиарда параметров.
// Если здесь нужно использовать такое форматирование - используем здесь.
export async function fetchOffers(
  ...params: Parameters<typeof fetchOffersService>
) {
  const offers = await fetchOffersService(...params)

  return offers.map(offer => ({
    ...offer,
    intervalCaption: formatOfferInterval(offer.tariff, offer.visitingIntervals)
      .full,
  }))
}

export const {fetchAddressSuggest} = suggestService
export const {
  fetchSuggest,
  fetchAddressPin,
  fetchPickupPoints, //
} = createPickupRouteService({suggestService})
